/**
 * Utility per la gestione della cache locale (localStorage)
 */

interface CacheEntry<T> {
  data: T;
  timestamp: number;
  expiry: number;
}

export const cache = {
  /**
   * Salva un oggetto in cache
   */
  set: <T>(key: string, data: T, ttlHours: number = 24): void => {
    try {
      const entry: CacheEntry<T> = {
        data,
        timestamp: Date.now(),
        expiry: ttlHours * 60 * 60 * 1000
      };
      localStorage.setItem(`gesvol_cache_${key}`, JSON.stringify(entry));
    } catch (e) {
      console.warn('Cache: Errore nel salvataggio (cache piena?)', e);
    }
  },

  /**
   * Recupera un oggetto dalla cache
   */
  get: <T>(key: string): T | null => {
    try {
      const stored = localStorage.getItem(`gesvol_cache_${key}`);
      if (!stored) return null;

      const entry: CacheEntry<T> = JSON.parse(stored);
      const now = Date.now();

      if (now - entry.timestamp > entry.expiry) {
        localStorage.removeItem(`gesvol_cache_${key}`);
        return null;
      }

      return entry.data;
    } catch (e) {
      console.warn('Cache: Errore nel recupero', e);
      return null;
    }
  },

  /**
   * Rimuove un oggetto specifico
   */
  remove: (key: string): void => {
    localStorage.removeItem(`gesvol_cache_${key}`);
  },

  /**
   * Svuota la cache (opzionalmente solo quella dell'app)
   */
  clear: (): void => {
    Object.keys(localStorage)
      .filter(key => key.startsWith('gesvol_cache_'))
      .forEach(key => localStorage.removeItem(key));
  }
};
